import { Box, Flex, useMantineTheme } from '@mantine/core';

import { useStyles } from './SectionTitleSkeleton.styles';

export function SectionTitleSkeleton() {
  const { classes, cx } = useStyles();
  const theme = useMantineTheme();

  return (
    <Flex
      justify="space-between"
      align="center"
      mb={theme.other.spacing._12}
      className={classes.container}
    >
      <Box className={cx(classes.skeleton, classes.title)} />
      <Box className={cx(classes.skeleton, classes.link)} />
    </Flex>
  );
}
